<template>
  <!-- Kontener zakresowego filtra: flexowy układ w wierszu -->
  <div class="filter d-flex">
    <!-- Etykieta filtra: wyświetla przekazaną nazwę -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora "od": wyświetlany z odpowiednią klasą -->
    <span class="symbol">{{ symbolFrom }}</span>
    <!-- Pole input dla wartości minimalnej:
         - atrybut name odpowiada props.fieldFromName
         - v-model.lazy wiąże wartość po zdarzeniu 'change'
         - blokada scrollowania i dotyku, aby zapobiec przypadkowym zmianom
    -->
    <input
      :name="fieldFromName"
      v-model.lazy="valueFrom"
      type="number"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol operatora "do": analogicznie do 'from' -->
    <span class="symbol">{{ symbolTo }}</span>
    <!-- Pole input dla wartości maksymalnej -->
    <input
      :name="fieldToName"
      v-model.lazy="valueTo"
      type="number"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                          // Importujemy reactive ref i funkcję watch
import { useCurrentFiltersStore } from "../../stores/currentFilters"; // Import store Pinia dla aktualnych filtrów

export default {
  name: "RangeFilter",                                     // Unikalna nazwa komponentu
  props: ["name", "symbolFrom", "fieldFromName", "symbolTo", "fieldToName"], // Definiujemy przekazywane propsy
  
  setup(props) {
    // Inicjalizacja store z aktualnymi filtrami
    const filtersStore = useCurrentFiltersStore();
    
    // Ustawienie początkowych wartości z store lub pustej wartości
    const valueFrom = ref(
      filtersStore.filters[props.fieldFromName] ?? ""
    );
    const valueTo = ref(
      filtersStore.filters[props.fieldToName] ?? ""
    );

    /**
     * Zapisuje podaną wartość do store pod odpowiednim kluczem
     * @param {string} fieldName - nazwa klucza w store.filters
     * @param {string|number} text - nowa wartość filtra
     */
    const saveValue = (fieldName, text) => {
      filtersStore.addItem(fieldName, text);
    };

    // Obserwator zmian obu wartości; zapisuje tylko gdy zmiana jest inna niż poprzednia
    watch(
      [valueFrom, valueTo],
      ([newFrom, newTo], [oldFrom, oldTo]) => {
        if (newFrom !== oldFrom) {
          saveValue(props.fieldFromName, newFrom);
        }
        if (newTo !== oldTo) {
          saveValue(props.fieldToName, newTo);
        }
      }
    );

    // Udostępniamy zmienne i store w template
    return { valueFrom, valueTo, filtersStore };
  },
};
</script>

<style scoped>
/* Usunięcie standardowych przycisków strzałek w input type=number dla WebKit */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Styl kontenera filtra: dolna granica i marginesy */
.filter {
  border-bottom: 1px solid #b7b7b5;
  padding-bottom: 5px;
  margin-top: 5px;
}

/* Usunięcie dolnej granicy dla ostatniego filtra */
.filter:last-child {
  border: none;
}

/* Styl pól input: szerokość, padding i wyśrodkowanie tekstu */
input {
  width: 50px;
  padding: 2px 7px;
  text-align: center;
}

/* Styl symbolu operatora */
.symbol {
  padding: 5px;
}
</style>
